import axios from "axios";
import { useState } from "react";
import { useGlobalModal } from "../context/SuccessModalProvider";
import { handleRouteNav } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetState, setAuthLogin } from "../redux/auth/loginSlice";
import { resetData } from "../redux/auth/loginDataSlice";
import { resetCartState } from "../redux/auth/cartRefreshSlice";
import { isDevMode } from "../constant";

const BASE_URL = isDevMode ? process.env.REACT_APP_BACKEND_BASE_TEST_URL : process.env.REACT_APP_BACKEND_BASE_URL;
export const apiFallBackMsg = "Network error";

export const postApi = async (endpoint, data, showPopup, errorHandler, successHandler) => {
  try {
    const res = await axios.post(`${BASE_URL}/${endpoint}`, data);
    if (res.data.status) {
      successHandler &&
        showPopup &&
        showPopup({
          title: null,
          content: <span className="custom-modal-title">{res.data.message}</span>,
          onOk: () => {
            successHandler(res.data);
            console.log("Confirmed!");
          },
          className: "custom-success-modal",
        });
      return res.data;
    }
    return {};
  } catch (error) {
    if (showPopup) {
      showPopup({
        title: null,
        content: <span className="custom-modal-title">{error.response?.data?.message || apiFallBackMsg}</span>,
        onOk: () => {
          errorHandler && errorHandler(error.response);
          console.log("Confirmed!");
        },
        className: "custom-success-modal",
      });
    }
    return false;
  }
};

export const getApi = async (endpoint) => {
  try {
    const res = await axios.get(`${BASE_URL}/${endpoint}`);
    if (res.data?.status) {
      return res.data;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const useApiCall = () => {
  const [loading, setLoading] = useState(false);
  const { showPopup } = useGlobalModal();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRoleId = useSelector((state) => state.auth.role_id);

  const postApi = async (endpoint, data, tempShowPopup, errorHandler, successHandler) => {
    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/${endpoint}`, data);
      // console.log("res from postApi:", res);
      if (tempShowPopup && res.data?.message) {
        showPopup({
          title: null,
          content: <span className="custom-modal-title">{res.data?.message}</span>,
          onOk: () => {
            successHandler && successHandler(res.data);
            console.log("Confirmed!");
          },
          className: "custom-success-modal",
        });
      }

      if (res.data?.is_deleted) {
        navigate(handleRouteNav("/login", userRoleId));
        dispatch(resetState());
        dispatch(resetData());
        dispatch(resetCartState());
      } else if (res.data?.is_blocked) {
        dispatch(setAuthLogin({ is_blocked: true, role_id: userRoleId }));
      }

      if (res.data?.status) {
        return res.data;
      }

      return {};
    } catch (error) {
      const errorMessage = error.response?.data?.message || apiFallBackMsg;
      console.log("error from postApi:", error);

      if (error.response?.data?.is_deleted) {
        navigate(handleRouteNav("/login", userRoleId));
        dispatch(resetState());
        dispatch(resetData());
        dispatch(resetCartState());
      } else if (error.response?.data?.is_blocked) {
        dispatch(setAuthLogin({ is_blocked: true, role_id: userRoleId }));
      }

      if (tempShowPopup) {
        showPopup({
          title: null,
          content: <span className="custom-modal-title">{errorMessage}</span>,
          onOk: () => {
            errorHandler && errorHandler(error.response);
            console.log("Confirmed!");
          },
          className: "custom-success-modal",
        });
      }

      return error.response?.data || false;
    } finally {
      setLoading(false);
    }
  };

  const getApi = async (endpoint, tempShowPopup, errorHandler, successHandler) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/${endpoint}`);
      if (res.data?.status) {
        if (tempShowPopup) {
          showPopup({
            title: null,
            content: <span className="custom-modal-title">{res.data?.message}</span>,
            onOk: () => {
              successHandler && successHandler(res.data);
              console.log("Confirmed!");
            },
            className: "custom-success-modal",
          });
        }
        return res.data;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || apiFallBackMsg;

      if (tempShowPopup) {
        showPopup({
          title: null,
          content: <span className="custom-modal-title">{errorMessage}</span>,
          onOk: () => {
            errorHandler && errorHandler(error.response);
            console.log("Confirmed!");
          },
          className: "custom-success-modal",
        });
      }

      return error.response?.data || false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, postApi, getApi };
};
